module.exports = __webpack_public_path__ + "static/media/easy_installation_bg_icon_svg.bf48185c.svg";